import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlider, MatSliderModule } from "@angular/material/slider";
import { TranslateModule } from "@ngx-translate/core";
import { Answer } from "../../../common/models/answer";
import { Question } from "../../../common/models/question";
import { EvaluationAthlete } from "../../../common/models/evaluation-athlete";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'evaluation-athlete-question',
  providers: [],
  styleUrls: ['./evaluation-athlete-question.scss'],
  standalone: true,
  imports: [
    MatSliderModule,
    TranslateModule,
    FormsModule
  ],
  templateUrl: './evaluation-athlete-question.html'
})
export class EvaluationAthleteQuestionComponent implements AfterViewInit {
    @Input() public answers: Answer[] = [];
    @Input() public question: Question = {} as Question;
    @Input() public evaluationAthlete: EvaluationAthlete = {} as EvaluationAthlete;
    @Input() public value :any;
    @Input() public isDesktop = true;

    @Output() public questionEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(
      private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    //

    public ngAfterViewInit() {
      this.changeDetectorRef.detectChanges();
    }

    public onSliderChange(event: any, formControlName: number) {
      this.questionEvent.emit([event, formControlName, this.value]);
      this.changeDetectorRef.detectChanges();
    }
}
